import { VendorSummaryComponent } from "./components/vendor-summary/vendor-summary.component";
import { VendorlistingComponent } from "./components/vendor-listing/vendor-listing.component";
import { VendorsComponent } from "./vendors.component";
import { VendorOpenPoComponent } from "./components/vendor-open-po/vendor-open-po.component";
import { VendorOpenLinesComponent } from "./components/vendor-open-lines/vendor-open-lines.component";
import { Routes } from "@angular/router";

export const vendorRoutes: Routes = [
  { path: "add-vendor", component: VendorsComponent },
  { path: "vendor-summary/:id", component: VendorSummaryComponent },
  { path: "", component: VendorlistingComponent },
  { path: "open-po/:id", component: VendorOpenPoComponent },
  { path: "open-lines/:id", component: VendorOpenLinesComponent },
];
